import React, { FC } from "react";
import { useField } from "formik";
import TextField, { TextFieldProps } from "../TextField";

type FormikTextFieldProps = {
  name: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: React.FocusEvent<HTMLInputElement>) => void;
} & Omit<
  TextFieldProps,
  | "value"
  | "multiline"
  | "onChange"
  | "onMouseDown"
  | "onFocus"
  | "onBlur"
  | "error"
>;

const FormikTextField: FC<FormikTextFieldProps> = ({
  name,
  helperText,
  onBlur,
  onChange,
  ...props
}) => {
  const [field, meta] = useField(name);
  const { touched, error } = meta;

  const innerHelperText = touched && Boolean(error) ? error : helperText;

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    field.onBlur(e);
    if (onBlur) {
      onBlur(e);
    }
  };

  const handleChange = (e: React.FocusEvent<HTMLInputElement>) => {
    field.onChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <TextField
      {...props}
      {...field}
      onBlur={handleBlur}
      onChange={handleChange}
      value={field.value || field.value === 0 ? field.value : ""}
      error={touched && Boolean(error)}
      helperText={innerHelperText}
    />
  );
};

export default FormikTextField;
